import React from "react";
import { Ruler } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const ROWS = [
  { size: "XS", chest: "32-34", waist: "26-28", length: "26" },
  { size: "S", chest: "35-37", waist: "29-31", length: "27" },
  { size: "M", chest: "38-40", waist: "32-34", length: "28" },
  { size: "L", chest: "41-43", waist: "35-37", length: "29" },
  { size: "XL", chest: "44-46", waist: "38-40", length: "30" },
];

const SizeGuide = () => (
  <Dialog>
    <DialogTrigger asChild>
      <button data-testid="size-guide-trigger" className="overline flex items-center gap-2 text-ash hover:text-crimson transition-colors">
        <Ruler size={14} /> Size Guide
      </button>
    </DialogTrigger>
    <DialogContent className="bg-[#141416] border border-line text-bone max-w-lg rounded-none" data-testid="size-guide-dialog">
      <DialogHeader>
        <DialogTitle className="font-serif text-3xl text-bone">Size & Fit Guide</DialogTitle>
      </DialogHeader>
      <p className="font-mono text-[10px] uppercase tracking-widest text-ash mb-4">All measurements in inches · Unisex garment fit</p>
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-line">
            {["Size", "Chest", "Waist", "Length"].map((h) => (
              <th key={h} className="text-left py-3 font-mono text-[10px] uppercase tracking-widest text-ash">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.size} className="border-b border-line/60">
              <td className="py-3 font-serif text-xl text-bone">{r.size}</td>
              <td className="py-3 text-ash text-sm">{r.chest}</td>
              <td className="py-3 text-ash text-sm">{r.waist}</td>
              <td className="py-3 text-ash text-sm">{r.length}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-6 border-t border-line pt-4">
        <p className="overline mb-2">How to Measure</p>
        <p className="text-ash text-sm leading-relaxed">
          <span className="text-bone">Chest:</span> measure around the fullest part.
          <span className="text-bone"> Waist:</span> measure at your natural waistline.
          Our ethnic silhouettes wear relaxed — size down for a closer fit.
        </p>
      </div>
    </DialogContent>
  </Dialog>
);

export default SizeGuide;
